import React, { useState } from 'react';
import { toast } from 'react-hot-toast';
import styled from 'styled-components';
import { Dropdown, Heading, Loader, Textarea } from '../../../UiKit';
import { Star } from '../../../UiKit/Star/Star';
import { useBlockUnBlockUser } from '../apis';
import Spinner from 'sushiweb/Spinner/Spinner';
import { grey } from 'sushiweb/tokens/color';
import Button from '../../../components/ComponentsV1/Button';

const blockReasonValue = {
  ZERO_TOLERANCE_POLICY: 'Zero tolerance policy',
  POLICY_NOT_FOLLOWED: 'Policy not followed',
  FRAUDULENT_ACTIVITY: 'Fraudulent Activity',
  ABUSING_CUSTOMER: 'Abusing Customer',
  OTHERS: 'Others',
};

function BlockUnblockAgent() {
  const [emails, setEmails] = useState('');
  const [action, setAction] = useState('');
  const [reason, setReason] = useState('');
  const [error, setError] = useState({});

  const { mutate, isLoading } = useBlockUnBlockUser(action, {
    onSuccess: () => {
      setEmails('');
      setAction('');
      setReason('');
      setError('');
    },
  });

  const validateEmail = (email) => {
    if (!email) return false;
    if (/\b[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Z|a-z]{2,}\b/.test(email)) {
      return true;
    }
    setError({ email: `${email} is an invalid email` });
    return false;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!emails) {
      setError({ email: 'Email is required.' });
      return null;
    }
    if (!action) {
      toast.error('Please select an action');
      return null;
    }
    if (action === 'block_user' && !reason) {
      toast.error('Please select a reason');
      return null;
    }
    let emailList = emails.split(',');
    let validEmails = true;
    emailList.forEach((email) => {
      if (!validateEmail(email)) {
        validEmails = false;
        return null;
      }
    });
    const queryBody = {
      email_ids: emailList,
      block_reason: reason,
    };
    if (validEmails) mutate(queryBody);
  };

  return (
    <FormConatiner>
      <div
        css={`
          display: flex;
          gap: 2rem;
          width: 100%;
          flex-wrap: wrap;
        `}
      >
        <FieldRowOne>
          <Label>
            <div>
              <Heading
                title='Email Ids'
                color='#1F1F1F'
                weight='600'
                size='17px'
              />
              <Star icon='*' />
            </div>
            <Textarea
              maxLimit={2000}
              showMaxLimit={true}
              showBtn={false}
              placeholder='Please enter comma separated email IDs'
              className='tw-p-5 focus:tw-border-green-500 focus:tw-ring-2 focus:tw-ring-green-500 focus:tw-outline-none'
              height='12rem'
              required
              value={emails}
              onChange={(e) => {
                setEmails(e.target.value);
              }}
              onFocus={() => {
                setError((prevState) => {
                  return { ...prevState, email: '' };
                });
              }}
              style={{
                outline: `${
                  error?.email
                    ? '1px solid #BF2938'
                    : '0.5px solid rgb(207, 207, 207)'
                }`,
                borderRadius: '8px',
                minHeight: '12rem',
              }}
            />
            {error?.email && (
              <div
                css={`
                  color: #bf2938;
                  margin-top: 0.5rem;
                `}
              >
                {error?.email}
              </div>
            )}
          </Label>
        </FieldRowOne>
        <FieldRowTwo>
          <Label
            style={{ width: '20%' }}
            onClickCapture={(event) => {
              event.preventDefault();
            }}
          >
            <div>
              <Heading
                title='Action'
                color='#1F1F1F'
                weight='600'
                size='17px'
              />
              <Star icon='*' />
            </div>
            <div
              css={`
                display: flex;
                flex-direction: row;
                gap: 1.5rem;
                width: '100%';

                & div {
                  width: 100%;
                }
              `}
              onClickCapture={(event) => {
                event.preventDefault();
              }}
            >
              <Dropdown
                dropDownValues={{
                  block_user: 'Block',
                  unblock_user: 'Unblock',
                }}
                onSelect={(value) => setAction(value)}
                dropdownVal={action}
                placeholder='Select an action'
              />
            </div>
          </Label>
          {action === 'block_user' ? (
            <>
              <Label
                css={`
                  width: 35%;
                  & div: {
                    width: 100%;
                  }
                `}
              >
                <div>
                  <Heading
                    title='Reason'
                    color='#1F1F1F'
                    weight='600'
                    size='17px'
                  />
                  <Star icon='*' />
                </div>
                <div
                  css={`
                    & div {
                      width: 100%;
                    }
                  `}
                >
                  <Dropdown
                    dropDownValues={blockReasonValue}
                    onSelect={(value) => {
                      setReason(value);
                    }}
                    dropdownVal={reason}
                    placeholder='Please Select a Reason'
                  />
                </div>
              </Label>
            </>
          ) : null}
        </FieldRowTwo>
      </div>
      <Button
        onClick={handleSubmit}
        loading={isLoading}
        title={'Submit'}
        className={'tw-w-fit'}
      />
    </FormConatiner>
  );
}

export default BlockUnblockAgent;

const FormConatiner = styled.div`
  width: 100%;
  height: fit-content;
  background-color: #fff;
  border-radius: 1rem;
  padding: 1.5rem;
  display: flex;
  gap: 4rem;
  flex-direction: column;
`;

const FieldRowOne = styled.div`
  width: 100%;
  display: flex;
  gap: 3rem;
`;
const FieldRowTwo = styled.div`
  width: 100%;
  display: flex;
  gap: 3rem;
`;

const Label = styled.label`
  width: 100%;
`;
